/**
 * CMS editors often paste text where every word is joined by a non-breaking
 * space. Those runs cannot wrap, so the line grows past the card.
 */
export function normalizeNbsp(html: string): string {
  return html.replace(/&nbsp;|&#160;|&#x0*a0;/gi, " ").replace(/\u00A0/g, " ");
}
